import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about">
      <div className="container">
        <h2 className="page-title">Qui suis-je</h2>
        
        <div className="about-content">
          <div className="about-image">
            <div className="creator-placeholder">
              <span>👩‍🎨</span>
              <p>Morgane</p>
            </div>
          </div>
          
          <div className="about-text">
            <h3 className="about-subtitle">Bonjour, je suis Morgane</h3>
            <p className="about-paragraph">
              Passionnée par la couture et le respect de l'environnement, j'ai créé 
              Maia&Ostara pour donner une seconde vie aux tissus et créer des vêtements 
              uniques qui racontent une histoire.
            </p>
            <p className="about-paragraph">
              Chaque création est pensée et réalisée avec soin dans mon atelier en France. 
              J'utilise exclusivement des tissus upcyclés, récupérés et transformés pour 
              créer des pièces originales qui allient style et éco-responsabilité.
            </p>
            <p className="about-paragraph">
              Mon inspiration vient de la nature, des fleurs et des saisons. J'aime créer 
              des vêtements qui célèbrent la féminité tout en respectant notre planète.
            </p>
            <p className="about-paragraph">
              Au-delà de la simple confection, je crois en une mode plus consciente, 
              où chaque pièce a une valeur et une histoire unique. Lorsque vous portez 
              une création Maia&Ostara, vous portez bien plus qu'un vêtement : vous portez 
              une philosophie et un engagement pour un monde plus durable.
            </p>
          </div>
        </div>

        <div className="values-section">
          <h3 className="section-heading">Mes valeurs</h3>
          <div className="values-grid">
            <div className="value-box">
              <span className="value-icon">🌱</span>
              <h4>Éco-responsabilité</h4>
              <p>Upcycling et valorisation des tissus pour une mode durable</p>
            </div>
            <div className="value-box">
              <span className="value-icon">🎨</span>
              <h4>Créativité</h4>
              <p>Des créations originales et uniques, jamais reproduites à l'identique</p>
            </div>
            <div className="value-box">
              <span className="value-icon">💝</span>
              <h4>Fait main</h4>
              <p>Chaque pièce est cousue avec amour et attention aux détails</p>
            </div>
            <div className="value-box">
              <span className="value-icon">🇫🇷</span>
              <h4>Local</h4>
              <p>Production française dans le respect des savoir-faire traditionnels</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
